export enum EnumFrequency {
    Monthly = 'Mensal',
    Bimonthly = 'Bimestral',
    Quarterly = 'Trimestral',
    Biannual = 'Semestral',
    Annual = 'Anual',
}

export const frequencies = Object.entries(EnumFrequency).map(([key, value]) => ({ value: key, label: value }));
